import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Source, SourceRequest } from "interfaces";

const initialState = {
  filters: {
    pageIndex: 1,
    pageSize: 10,
    globalSearch: "",
    topicIdList: null,
    sorting: null,
  },
  hasNextPage: true,
  loading: false,
  firstLoad: true,
  sortedColumn: null,
  sortedDirection: null,
  sourcesList: [] as Source[],
  isLoadingSources: false,
  currentSource: null,
};

const gestioneSources = createSlice({
  name: "gestioneSources",
  initialState,
  reducers: {
    setIsLoadingSources: (state: any, action) => {
      state.isLoadingSources = action.payload;
    },
    setSources: (state: any, action: PayloadAction<Source[]>) => {
      state.sourcesList = [...action.payload];
    },
    addSources: (state: any, action: PayloadAction<Source[]>) => {
      state.sourcesList = [...state.sourcesList, ...action.payload];
    },
    nextPageSources: (state) => {
      state.filters.pageIndex++;
    },
    setPageSourcesAndSize: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload.page ?? state.filters.pageIndex,
        pageSize: action.payload.size ?? state.filters.pageSize,
      });
    },
    setPageSources: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload,
      });
    },
    setSizeSources: (state, action) => {
      state.filters.pageSize = action.payload;
    },
    setSearchTermSources: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        globalSearch: action.payload,
      });
    },
    setTopicSources: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        topicIdList: action.payload,
      });
    },
    setSortingSources: (state, action) => {
      state.sortedColumn = action.payload.sortedColumn;
      state.sortedDirection = action.payload.sortedDirection;
      Object.assign(state.filters, {
        pageIndex: 1,
        sorting: action.payload.sorting,
      });
    },
    setCurrentSource: (state: any, action: any) => {
      state.currentSource = action.payload;
    },
    resetFiltersSources: () => {
      return initialState;
    },
    updateSource: (state: any, action: PayloadAction<SourceRequest>) => {
      state.currentSource = JSON.parse(JSON.stringify(action.payload));
    },
    setHasNextPageSources: (state, action) => {
      state.hasNextPage = action.payload;
    },
    setLoadingSources: (state, action) => {
      state.loading = action.payload;
    },
    setFirstLoadSources: (state, action) => {
      state.firstLoad = action.payload;
    },
    resetStateSources: (state) => {
      return initialState;
    },
    updateSourceStatusById: (state, action) => {
      const sourceIndex = state.sourcesList.findIndex(
        (source) => source.id === action.payload
      );

      if (sourceIndex !== -1) {
        state.sourcesList[sourceIndex].aiStatus = "ENQUEUED";
      }
    },
  },
});

export const {
  nextPageSources,
  setPageSources,
  setSizeSources,
  setSearchTermSources,
  setSortingSources,
  resetFiltersSources,
  updateSource,
  setSources,
  setPageSourcesAndSize,
  setIsLoadingSources,
  setTopicSources,
  addSources,
  setCurrentSource,
  setHasNextPageSources,
  setLoadingSources,
  setFirstLoadSources,
  resetStateSources,
  updateSourceStatusById,
} = gestioneSources.actions;

export default gestioneSources.reducer;
